module.exports = __webpack_public_path__ + "static/media/f6f5c891-b04b-4663-8a54-29e29f08229b.1ae64473.JPG";